import React from "react";
import { useState } from "react";
import Page from "../components/Page";
import { EgresosHead } from "../sections/@dashboard/egresos/";
import EgresosTable from "../sections/@dashboard/egresos/EgresosTable";
import {
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Container } from "@mui/system";
import useAuth from "../hooks/useAuth";
const Egresos = () => {
  const { sideBarMenu } = useAuth();
  const [openDialog, setOpenDialog] = useState(false);
  const [title, setTitle] = useState("");
  const [bodyDialog, setBodyDialog] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorGraph, setErrorGraph] = useState({
    severity: "",
    mensaje: "",
  });

  //Validar que el usuario tenga permisos
  let f = JSON.parse(sideBarMenu);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };

  return (
    <>
      {f.find((r) => r.title === "Egresos")?.title === "Egresos" && (
        <Page title="Egresos">
          <Container maxWidth="xl">
            <EgresosHead
              setOpenDialog={setOpenDialog}
              setBodyDialog={setBodyDialog}
              setTitle={setTitle}
              setErrorGraph={setErrorGraph}
              setOpenSnackBar={setOpenSnackBar}
            />
            <Card>
              <EgresosTable
                setOpenDialog={setOpenDialog}
                setBodyDialog={setBodyDialog}
                setErrorGraph={setErrorGraph}
                setOpenSnackBar={setOpenSnackBar}
              />
            </Card>
          </Container>
          <Dialog open={openDialog} fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{bodyDialog}</DialogContent>
          </Dialog>
          <Snackbar
            open={openSnackBar}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity={errorGraph.severity}
              sx={{ width: "100%" }}
            >
              {errorGraph.mensaje}
            </Alert>
          </Snackbar>
        </Page>
      )}
    </>
  );
};

export default Egresos;
